<template>
  <div
    v-if="label"
    class="ai-token-usage"
    :class="{ 'ai-token-usage-over': over }"
    :title="detail"
  >{{ label }}</div>
</template>

<script>
import { tokenUsageDetail, tokenUsageLabel } from '../../../shared/ai-token-allowance.js'
import { AI_TOKEN_USAGE_EVENT } from '../lib/ai-token-usage.js'

export default {
  name: 'AiTokenUsage',
  data () {
    return {
      usage: null
    }
  },
  computed: {
    label () {
      return this.usage ? tokenUsageLabel(this.usage) : ''
    },
    detail () {
      return tokenUsageDetail(this.usage)
    },
    over () {
      return !!(this.usage && this.usage.allotment > 0 && this.usage.totalTokens >= this.usage.allotment)
    }
  },
  mounted () {
    this.onUsage = (event) => {
      if (event && event.detail) this.usage = event.detail
    }
    window.addEventListener(AI_TOKEN_USAGE_EVENT, this.onUsage)
    this.refresh()
  },
  beforeUnmount () {
    window.removeEventListener(AI_TOKEN_USAGE_EVENT, this.onUsage)
  },
  methods: {
    async refresh () {
      try {
        const response = await this.$http.get(`${VUE_APP_PROXY_SERVER_URL}/ai-usage`)
        if (response && response.data && typeof response.data.totalTokens === 'number') {
          this.usage = response.data
        }
      } catch (error) {}
    }
  }
}
</script>

<style scoped>
.ai-token-usage {
  margin-top: 6px;
  color: #8a8a84;
  font-size: 0.75rem;
  line-height: 1.3;
}

.ai-token-usage-over {
  color: #e08a4f;
}
</style>
